import React, { useState, useEffect, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import DatePicker, { registerLocale } from "react-datepicker";
import ResultModal from "../Common/ResultModal";
import iconcontentcalendar from "../../Images/Icons/iconcontentcalendar.png";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import Tooltip from "../Common/Tooltip";
import NumberFormat from "react-number-format";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import { posServices, globalServices, tenantService } from "../../Services";
import { validationService } from "../../Services/validation.service";
import {
  numbersOnly,
  posTag,
  lettersAndNumbers,
  ictNumber,
} from "../../Config/Regex";
import AsyncSelect from "react-select/async";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import { roles } from "../../Config/Roles";
import Select from "react-select";
registerLocale("hr", hr);
registerLocale("en", en);

const EditPOS = ({ match }) => {
  const history = useHistory();
  const { master, admin, support } = roles;
  const { userId, roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [backUrl, setBackUrl] = useState();
  const { locName, locTenant, locStore, selectedLanguageId } =
    useContext(GlobalContext);

  const [stores, setStores] = React.useState();
  const [pos, setPos] = useState();

  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  const { register, handleSubmit, errors, control, formState, setValue, watch } =
    useForm({
      mode: "onChange",
      reValidateMode: "onChange",
      defaultValues: { pos },
    });

  const watchedPaymentAppId = watch("paymentAppId");
  const watchedPosTypeId = watch("posTypeId");
  const isSoftPos = Number(watchedPosTypeId || pos?.posTypeId) === 2;

  useEffect(() => {
    if (![master, admin, support].includes(Number(roleId)))
      history.push("/error-page/401");

    switch (locName) {
      case "tenants":
        setBackUrl(`/${locName}/${locTenant}`);
        break;
      case "stores":
        setBackUrl(`/${locName}/${locStore}`);
        break;
      default:
        setBackUrl(`/${locName}`);
    }
    setPos({
      tenantId: locTenant || "0",
      storeId: locStore || "0",
      tag: "",
      description: "",
      documentNumber: "",
      deposit: "",
      workingMode: false,
      posSerialNumber: "",
      subscriptionValidFrom: null,
      //subscriptionValidTo: null,
      closeArticleSearch: false,
      multiDraft: false,
      cashDefault: false,
      tid: "",
      msisdn: "",
      fiscalMode: true,
      paymentAppId: "",
      posTypeId: "",
      terminalName: "",
      // msisdnPrefix: "",
      // msisdnCountry: "",
    });

    if (locTenant && locTenant != "0") {
      tenantService
        .getTenantSetting(locTenant)
        .then((res) => {
          if (res) {
            setPos((prevState) => ({
              ...prevState,
              closeArticleSearch: res.data.closeArticleSearch,
              multiDraft: res.data.multiDraft,
              cashDefault: res.data.cashDefault,
              fiscalMode: true,
            }));
          }
        })
        .catch((err) => console.log("err", err));
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (pos && pos.tenantId != "0") {
      globalServices.getStoresByTenantId(pos.tenantId).then((res) => {
        setStores(res.data);
      });
    }
  }, [pos]);
  const getStores = (id) => {
    setPos({ ...pos, storeId: 0 });
    globalServices.getStoresByTenantId(id).then((res) => {
      setStores(res.data);
    });
  };
  // stores - kad se stores učita znamo da je forma spremna
  useEffect(() => {
    if (stores) {
      setIsLoading(false);
    }
  }, [stores]);

  const onSubmit = (data) => {
    console.log("data", data);
    posServices
      .create({
        tenantId: data.tenantId.value && parseInt(data.tenantId.value),
        storeId: data.storeId.value && parseInt(data.storeId.value),
        tag: data.tag,
        description: data.description,
        workingMode: data.workingMode,
        documentNumber: data.documentNumber && Number(data.documentNumber),
        deposit: parseFloat(convertToDecimalString(data.deposit)),
        posserialNumber: data.posSerialNumber,
        inventoryNumber: data.inventoryNumber,
        subscriptionValidFrom: data.subscriptionValidFrom,
        //subscriptionValidTo: data.subscriptionValidTo,
        closeArticleSearch: data.closeArticleSearch,
        multiDraft: data.multiDraft,
        cashDefault: data.cashDefault,
        tid: data.tid,
        msisdn: data.msisdn,
        fiscalMode: data.fiscalMode,
        modeId: 1,
        paymentAppId: data.paymentAppId ? Number(data.paymentAppId) : null,
        posTypeId: data.posTypeId ? Number(data.posTypeId) : null,
        terminalName: Number(data.paymentAppId) === 2 ? data.terminalName : null,
        // msisdn: data.msisdnCountry + data.msisdnPrefix + data.msisdn,
      })
      .then((res) => {
        res.data.success
          ? setResultModal({
              show: true,
              title: translator("EditPOS-Add-SuccessModal-Title"),
              text: translator("EditPOS-Add-SuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: true,
            })
          : setResultModal({
              show: true,
              title: translator("EditPOS-Add-UnsuccessModal-Title"),
              text: translator("EditPOS-Add-UnsuccessModal-Text"),
              btnClass: "btn btn-primary",
              success: false,
            });
      })
      .catch((err) =>
        setResultModal({
          show: true,
          title: translator("EditPOS-Add-UnsuccessModal-Title"),
          text: translator("EditPOS-Add-UnsuccessModal-Text"),
          btnClass: "btn btn-primary",
          success: false,
        })
      );
  };

  const goBack = () => {
    history.push(backUrl);
  };
  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        if (Number(locTenant) > 0) {
          setValue("tenantId", {
            id: Number(locTenant),
            value: Number(locTenant),
            label: res.data.filter((e) => e.id === Number(locTenant))[0].name,
          });
        }
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.id,
        }));
        result.unshift({
          id: 0,
          label: translator("SelectTenant-Choose"),
          value: 0,
        });
        return result;
      })
      .catch((err) => err);
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    goBack();
  };

  return (
    <CardWrap
      title={translator("EditPOS-Title")}
      subtitle={translator("POS-CreatePOS-SubTitle")}
      backUrl={backUrl}
    >
      {isLoading && <SpinnerLoading />}
      {!isLoading && pos && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("POS-New_EditPOS-BasicInformation")}
              </legend>

              <div className="form-group">
                <label htmlFor="ddlStore">{translator("EditPOS-Tenant")}</label>{" "}
                <Tooltip text={translator("POS-Tenant-Msg")} />
                <Controller
                  as={AsyncSelect}
                  control={control}
                  name="tenantId"
                  onChange={(event) => {
                    setValue("storeId", null, {
                      shouldValidate: true,
                    });
                    getStores(event[0].id);
                    return event[0];
                  }}
                  placeholder={translator("Select-Tenant")}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                />
              </div>

              {errors.tenantId && errors.tenantId.type === "validate" && (
                <p className="text-danger">
                  {translator("ValidationMsg-RequiredField")}
                </p>
              )}

              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("POS-New_EditPOS-Store")}
                </label>{" "}
                <Tooltip text={translator("POS-Store-Msg")} />
                {stores && (
                  <Controller
                    as={Select}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.id,
                      }))
                    }
                    name="storeId"
                    placeholder={translator("Select-Store")}
                    rules={{
                      validate: function (value) {
                        if (!value) return false;
                        return value.value === null ? false : true;
                      },
                    }}
                    control={control}
                    onChange={(event) => event[0]}
                  />
                )}
                {errors.storeId && errors.storeId.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group">
                <label>TID</label> <Tooltip text={translator("POS-TID-Msg")} />
                <input
                  type="number"
                  className="form-control"
                  ref={register({
                    required: false,
                    min: 12700000,
                    max: 12709999,
                    validate: function (value) {
                      if (value != "") {
                        return validationService.validateTid(
                          document.getElementsByName("tid")[0].value
                        );
                      }
                      return true;
                    },
                  })}
                  name="tid"
                  defaultValue={pos.tid}
                />
                {/* {errors.tid && errors.tid.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )} */}
                {errors.tid &&
                  (errors.tid.type === "min" || errors.tid.type === "max") && (
                    <p className="text-danger">
                      {translator("TIDLength-ValidationMsg")}
                    </p>
                  )}
                {errors.tid && errors.tid.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-TidInUse")}
                  </p>
                )}
              </div>
              {!isSoftPos && (
                <>
                  <div className="form-group">
                    <label>{translator("ICT-number")}</label>{" "}
                    <Tooltip text={translator("POS-ICTNum-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: isSoftPos,
                        pattern: ictNumber,
                        maxLength: 25,
                        validate: () =>
                          validationService.validatePosInventoryNumber(
                            document.getElementsByName("inventoryNumber")[0].value
                          ),
                      })}
                      name="inventoryNumber"
                      defaultValue={pos.inventoryNumber}
                    />
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "pattern" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-LettersAndNumbers")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength25")}
                        </p>
                      )}
                    {errors.inventoryNumber &&
                      errors.inventoryNumber.type === "validate" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-ICTinUse")}
                        </p>
                      )}
                  </div>

                  <div className="form-group">
                    <label>{translator("POS-New_EditPOS-POSSerialNumber")}</label>{" "}
                    <Tooltip text={translator("POS-SerialNumber-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: isSoftPos,
                        pattern: numbersOnly,
                        maxLength: 50,
                        validate: () =>
                          validationService.validatePosSerialNumber(
                            document.getElementsByName("posSerialNumber")[0].value
                          ),
                      })}
                      name="posSerialNumber"
                      defaultValue={pos.posSerialNumber}
                    />
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "pattern" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-NumbersOnly")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "maxLength" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-MaxLength50")}
                        </p>
                      )}
                    {errors.posSerialNumber &&
                      errors.posSerialNumber.type === "validate" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-SerialNumberInUse")}
                        </p>
                      )}
                  </div>

                  <div className="form-group">
                    <label>{translator("POSdevice-MSISDN")}</label>{" "}
                    <Tooltip text={translator("POS-MSISDN-Msg")} />
                    <input
                      type="text"
                      className="form-control"
                      ref={register({
                        required: true,
                        maxLength: 50,
                      })}
                      name="msisdn"
                      defaultValue={pos.msisdn}
                    />
                    {errors.msisdn && (
                      <>
                        {errors.msisdn.type === "required" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-RequiredField")}
                          </p>
                        )}
                        {errors.msisdn.type === "pattern" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-NumbersOnly")}
                          </p>
                        )}
                        {errors.msisdn.type === "maxLength" && (
                          <p className="text-danger">
                            {translator("ValidationMsg-MaxLength50")}
                          </p>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}

              {isSoftPos && (
                <>
                  <div className="form-group">
                    <label>Manufacturer</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="manufacturer"
                      defaultValue={pos.manufacturer || ""}
                      disabled
                    />
                  </div>

                  <div className="form-group">
                    <label>Operation System</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="operationSystem"
                      defaultValue={pos.operationSystem || ""}
                      disabled
                    />
                  </div>

                  <div className="form-group">
                    <label>Mode</label>
                    <input
                      type="text"
                      className="form-control"
                      ref={register()}
                      name="softPosMode"
                      defaultValue={pos.softPosMode || ""}
                      disabled
                    />
                  </div>
                </>
              )}
            </fieldset>
          </div>

          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditPOS-MoreDetails")}
              </legend>

              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Deposit")}</label>{" "}
                <Tooltip text={translator("POS-Deposit-Msg")} />
                <Controller
                  name="deposit"
                  control={control}
                  rules={{ maxLength: 9 }}
                  as={
                    <NumberFormat
                      thousandSeparator={" "}
                      decimalSeparator={","}
                      fixedDecimalScale={true}
                      decimalScale={2}
                      placeholder={"0,00"}
                      inputMode="numeric"
                      className="form-control"
                    />
                  }
                  defaultValue={pos.deposit}
                />
                {errors.deposit && errors.deposit.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-Deposit")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Tag")}</label>{" "}
                <Tooltip text={translator("POS-Tag-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  ref={register({
                    //required: true,
                    pattern: posTag,
                    validate: () =>
                      validationService.validatePosTag(
                        document.getElementsByName("tag")[0].value,
                        document.getElementsByName("storeId")[0].value,
                        document.getElementsByName("tenantId")[0].value
                      ),
                  })}
                  name="tag"
                  defaultValue={pos.tag}
                />
                {errors.tag && (
                  <>
                    {/* {errors.tag.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )} */}
                    {errors.tag && errors.tag.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-TagNotValid")}
                      </p>
                    )}
                    {errors.tag.type === "pattern" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-PosTag")}
                      </p>
                    )}
                  </>
                )}
              </div>
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-Description")}</label>{" "}
                <Tooltip text={translator("POS-Description-Msg")} />
                <textarea
                  id="textArea"
                  rows="5"
                  className="form-control"
                  name="description"
                  ref={register({ maxLength: 250 })}
                  defaultValue={pos.description}
                />
                {errors.description &&
                  errors.description.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
              </div>

              <div className="form-group">
                <label>{translator("POS-New_EditPOS-DocumentNumber")}</label>{" "}
                <Tooltip text={translator("POS-DocumentNumber-Msg")} />
                <input
                  type="number"
                  className="form-control"
                  ref={register({
                    required: true,
                    max: 999999,
                    pattern: numbersOnly,
                  })}
                  name="documentNumber"
                  defaultValue={pos.documentNumber}
                />
                {errors.documentNumber &&
                  errors.documentNumber.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {errors.documentNumber &&
                  errors.documentNumber.type === "max" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength6")}
                    </p>
                  )}
                {errors.documentNumber &&
                  errors.documentNumber.type === "pattern" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-NumberOnly")}
                    </p>
                  )}
              </div>
            </fieldset>
          </div>

          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("POS-New_EditPOS-OtherData")}
              </legend>
              <div className="form-group">
                <label>
                  {translator("POS-New_EditPOS-SubscriptionValidFrom")}
                </label>{" "}
                <Tooltip text={translator("POS-FromDate-Msg")} />
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    showYearDropdown={true}
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="subscriptionValidFrom"
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    defaultValue={
                      pos.subscriptionValidFrom !== null
                        ? new Date(pos.subscriptionValidFrom)
                        : ""
                    }
                    onChange={function ([selected]) {
                      setPos({ ...pos, subscriptionValidFrom: selected });
                      return selected;
                    }}
                    // maxDate={
                    //   pos.subscriptionValidTo !== null
                    //     ? new Date(pos.subscriptionValidTo)
                    //     : ""
                    // }
                  />
                </div>
                {errors.subscriptionValidFrom &&
                  errors.subscriptionValidFrom.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>

              {/* <div className="form-group">
                <label>
                  {translator("POS-New_EditPOS-SubscriptionValidTo")}
                </label>{" "}
                <Tooltip text={translator("POS-ToDate-Msg")} />
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text" id="basic-addon1">
                      <img src={iconcontentcalendar} alt="calendar" />
                    </span>
                  </div>
                  <Controller
                    as={DatePicker}
                    control={control}
                    autoComplete="off"
                    className="form-control"
                    dateFormat="dd.MM.yyyy"
                    name="subscriptionValidTo"
                    showYearDropdown={true}
                    rules={{ required: true }}
                    locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                    valueName="selected"
                    defaultValue={
                      pos.subscriptionValidTo !== null
                        ? new Date(pos.subscriptionValidTo)
                        : ""
                    }
                    onChange={function ([selected]) {
                      setPos({ ...pos, subscriptionValidTo: selected });
                      return selected;
                    }}
                    minDate={new Date(pos.subscriptionValidFrom)}
                  />
                </div>
                {errors.subscriptionValidTo &&
                  errors.subscriptionValidTo.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div> */}
              <div className="form-group">
                <label>{translator("POS-New_EditPOS-PaymentType")}</label>
                <select
                  name="paymentAppId"
                  ref={register()}
                  className="form-control"
                  defaultValue={pos.paymentAppId || ""}
                >
                  <option value="">-</option>
                  <option value={1}>Combis</option>
                  <option value={2}>Monri</option>
                  {/* <option value={3}>Worldline</option> */}
                </select>
              </div>
              {Number(watchedPaymentAppId) === 2 && (
                <div className="form-group">
                  <label>{translator("POS-New_EditPOS-TerminalName")}</label>
                  <input
                    type="text"
                    className="form-control"
                    ref={register({ required: true, maxLength: 100 })}
                    name="terminalName"
                    defaultValue={pos.terminalName}
                  />
                  {errors.terminalName &&
                    errors.terminalName.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  {errors.terminalName &&
                    errors.terminalName.type === "maxLength" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-MaxLength100")}
                      </p>
                    )}
                </div>
              )}
              <div className="form-group">
                <label>POS Type</label>
                <select
                  name="posTypeId"
                  ref={register()}
                  className="form-control"
                  defaultValue={pos.posTypeId || 1}
                >
                  <option value="">-</option>
                  <option value={1}>Pax</option>
                 
                </select>
              </div>
              <div className="row">
                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="fiscalMode"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.fiscalMode : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>{translator("Fiskalni uređaj")}</span>{" "}
                  <Tooltip
                    text={translator(
                      "Ukoliko želite da blagjana radi kao ne fiskalni uređaj, isključite ovu opciju."
                    )}
                  />
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="closeArticleSearch"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.closeArticleSearch : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-CloseAricleSearch")}
                  </span>{" "}
                  <Tooltip text={translator("POS-CloseAricleSearch-Msg")} />
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="multiDraft"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.multiDraft : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-MultiDraft")}
                  </span>{" "}
                  <Tooltip text={translator("POS-MultiDraft-Msg")} />
                </div>

                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="cashDefault"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.cashDefault : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-CashDefault")}
                  </span>{" "}
                  <Tooltip text={translator("POS-CashDefault-Msg")} />
                </div>
                <div className="form-group col-12">
                  <label className="labelCont">
                    <input
                      type="checkbox"
                      name="workingMode"
                      ref={register}
                      defaultChecked={
                        pos.tenantId !== "" ? pos.workingMode : false
                      }
                    />
                    <span className="checkmark"></span>
                  </label>
                  <span>
                    {translator("POS-New_EditPOS-Checkbox-WorkingMode")}
                  </span>{" "}
                  <Tooltip
                    text={translator(
                      "Odaberite Prod rad ako želite produkcijsku fiskalizaciju. Uvijek treba biti označeno."
                    )}
                  />
                </div>
              </div>
            </fieldset>
          </div>
          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("POS-New_EditPOS-Close")}
            </button>
            &nbsp;
            <button
              className="btn btn-primary"
              disabled={!formState.dirty}
              type="submit"
            >
              {translator("POS-New_EditPOS-Save")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditPOS;
